import { px, rect, cRect, CENTER } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

export const hull_round: Hull = {
  id: 'hull_round',
  name: 'Round',
  drawBody: (ctx, p) => {
    const cy = 34;
    const drawOval = (rx, ry, color) => {
      for (let y = -ry; y <= ry; y++) for (let x = -rx; x < rx; x++) {
        const fx = x + 0.5;
        if ((fx*fx)/(rx*rx) + (y*y)/(ry*ry) <= 1) px(ctx, CENTER + x, cy + y, color);
      }
    };
    drawOval(9, 7, p.primary);
    for (let y = 1; y <= 7; y++) for (let x = -9; x < 9; x++) {
      const fx = x + 0.5;
      const r = (fx*fx)/81 + (y*y)/49;
      if (r <= 1 && r > 0.55) px(ctx, CENTER + x, cy + y, p.shadow);
    }
    for (let x = -7; x < 7; x++) {
      const fx = x + 0.5;
      const yMax = Math.floor(7 * Math.sqrt(Math.max(0, 1 - (fx*fx)/81)));
      if (yMax >= 5) px(ctx, CENTER + x, cy + yMax, p.dark);
    }
    cRect(ctx, cy - 6, 10, 1, p.light);
    cRect(ctx, cy - 1, 4, 2, p.accent);
  },
  mounts: {
    [SLOT.COCKPIT]:    { anchor: { x: 32, y: 31 }, base: (ctx, p) => cRect(ctx, 32, 6, 1, p.dark) },
    [SLOT.WING_L]:     { anchor: { x: 22, y: 34 }, cap: (ctx, p) => { rect(ctx, 22, 33, 3, 3, p.shadow); px(ctx, 22, 33, p.dark); } },
    [SLOT.WING_R]:     { anchor: { x: 41, y: 34 }, cap: (ctx, p) => { rect(ctx, 39, 33, 3, 3, p.shadow); px(ctx, 41, 33, p.dark); } },
    [SLOT.ENGINE_L]:   { anchor: { x: 28, y: 41 }, cap: (ctx, p) => { rect(ctx, 27, 39, 3, 3, p.shadow); rect(ctx, 27, 39, 3, 1, p.dark); } },
    [SLOT.ENGINE_R]:   { anchor: { x: 36, y: 41 }, cap: (ctx, p) => { rect(ctx, 34, 39, 3, 3, p.shadow); rect(ctx, 34, 39, 3, 1, p.dark); } },
    [SLOT.WEAPON_TOP]: { anchor: { x: 32, y: 27 }, base: (ctx, p) => { cRect(ctx, 28, 4, 2, p.metalDark); cRect(ctx, 28, 4, 1, p.metal); } },
    [SLOT.NOSE]:       { anchor: { x: 32, y: 27 } },
  },
};
